import type { FunctionComponent, PropsWithChildren } from 'react';
import { useEffect } from 'react';
import { HashRouter, useLocation, useNavigate, useSearchParams } from 'react-router';

const HashChangeRouter: FunctionComponent<PropsWithChildren> = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const partnerUuid = searchParams.get('partnerUuid');

    useEffect(() => {
        const onHashChange = () => {
            const changedUrl = window.location.hash;
            const newUrl = changedUrl.slice(1).split('?')[0];
            if (location.pathname !== newUrl) {
                const urlToRouteTo = partnerUuid ? `${newUrl}/${partnerUuid}` : newUrl;
                navigate(urlToRouteTo);
            }
        };
        window.addEventListener('hashchange', onHashChange);

        return () => {
            window.removeEventListener('hashchange', onHashChange);
        };
    }, [location, navigate, partnerUuid]);

    return <>{children}</>;
};

export const HashRoutingProvider: FunctionComponent<PropsWithChildren> = ({ children }) => (
    <HashRouter>
        <HashChangeRouter>{children}</HashChangeRouter>
    </HashRouter>
);
